module.exports = __webpack_public_path__ + "fa-regular-400.aeabb944b103a5e0e032.eot";


//////////////////
// WEBPACK FOOTER
// /home/vatzcar/public_html/Exchange-NewsAdmin-Frontend/src/assets/fonts/webfonts/fa-regular-400.eot
// module id = ../../../../../src/assets/fonts/webfonts/fa-regular-400.eot
// module chunks = styles